import _objectWithoutProperties from "/home/runner/work/design/design/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["icon", "block", "className", "contrast", "disabled", "sx", "theme", "width", "minWidth", "maxWidth", "variant"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import classnames from 'classnames';
import React from 'react';
import UnstyledTextInput from './_UnstyledTextInput';
import TextInputWrapper from './_TextInputWrapper'; // using forwardRef is important so that other components (ex. SelectMenu) can autofocus the input

var TextInput = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var IconComponent = _ref.icon,
      block = _ref.block,
      className = _ref.className,
      contrast = _ref.contrast,
      disabled = _ref.disabled,
      sxProp = _ref.sx,
      theme = _ref.theme,
      widthProp = _ref.width,
      minWidthProp = _ref.minWidth,
      maxWidthProp = _ref.maxWidth,
      variantProp = _ref.variant,
      inputProps = _objectWithoutProperties(_ref, _excluded);

  // this class is necessary to style FilterSearch, plz no touchy!
  var wrapperClasses = classnames(className, 'TextInput-wrapper');
  return /*#__PURE__*/React.createElement(TextInputWrapper, {
    block: block,
    className: wrapperClasses,
    contrast: contrast,
    disabled: disabled,
    hasIcon: !!IconComponent,
    sx: sxProp,
    theme: theme,
    width: widthProp,
    minWidth: minWidthProp,
    maxWidth: maxWidthProp,
    variant: variantProp
  }, IconComponent && /*#__PURE__*/React.createElement(IconComponent, {
    className: "TextInput-icon"
  }), /*#__PURE__*/React.createElement(UnstyledTextInput, _extends({
    ref: ref,
    disabled: disabled
  }, inputProps)));
});
TextInput.defaultProps = {
  type: 'text'
};
TextInput.displayName = 'TextInput';
export default TextInput;